import React, { useState } from "react";
import firebase from "../firebase";
import emailjs from "emailjs-com";

const AddUser = (props) => {
  const [values, setValues] = useState({
    name: "",
    mobile: "",
    dege: "Assistant Professor",
    coll: "",
    sec: props.sec.sec,
    email: props.sec.email,
    state: "Haryana",
  });
  const handleChange = (e) => {
    var { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    firebase.firestore().collection(`user`).doc(`${props.sec.sec}`).set(values);
    emailjs
      .sendForm(
        "service_fed3346",
        "template_temhnjh",
        e.target,
        "user_2qNETUG5Dtqv2M3G6vC8J"
      )
      .then(
        () => {
          //console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );

    props.setCheck(true);
  };
  return (
    <div>
      {props.sec.email === "sskundugmnc@gmail.com" ? (
        <div>
          <h1 style={{ textAlign: "center" }}>Webinar Registration Form</h1>
          <p style={{ textAlign: "center" }}>
            This Form can Only be Accessed By You😇😇😇
          </p>
          <p style={{ textAlign: "center" }}>
            <b>You have been Granted a VIP Registration Access</b>
          </p>
          <form style={{ textAlign: "center" }} onSubmit={handleSubmit}>
            <input type="hidden" name="email" value={values.email} />
            <label htmlFor="name">Full Name:</label>
            <br />
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              id="name"
              value={values.name}
              required
              onChange={handleChange}
              className="add"
            />
            <br />
            <label htmlFor="mobile">WhatsApp Number:</label>
            <br />
            <input
              type="number"
              name="mobile"
              placeholder="WhatsApp Number"
              id="mobile"
              value={values.mobile}
              required
              onChange={handleChange}
              className="add"
            />
            <br />
            <label htmlFor="prof">Select Your Designation</label>
            <br />
            <select
              type="select"
              name="dege"
              id="prof"
              value={values.dege}
              required
              onChange={handleChange}
              className="add"
            >
              <option value="Assistant Professor">Assistant Professor</option>
              <option value="Professor">Professor</option>
              <option value="Associate Professor">Associate Professor</option>
              <option value="Student">Student</option>
            </select>
            <br />
            <label htmlFor="colle">Enter Your College/Institute Name</label>
            <br />
            <textarea
              name="coll"
              className="add"
              value={values.coll}
              required
              onChange={handleChange}
              id="colle"
              placeholder="Enter your College/Institute Name"
            ></textarea>
            <br />
            <label htmlFor="state"> Select Your State/Union Territories</label>
            <br />
            <select
              name="state"
              id="state"
              className="add"
              onChange={handleChange}
            >
              <option value="Andhra Pradesh">Andhra Pradesh</option>
              <option value="Andaman and Nicobar Islands">
                Andaman and Nicobar Islands
              </option>
              <option value="Arunachal Pradesh">Arunachal Pradesh</option>
              <option value="Assam">Assam</option>
              <option value="Bihar">Bihar</option>
              <option value="Chandigarh">Chandigarh</option>
              <option value="Chhattisgarh">Chhattisgarh</option>
              <option value="Dadar and Nagar Haveli">
                Dadar and Nagar Haveli
              </option>
              <option value="Daman and Diu">Daman and Diu</option>
              <option value="Delhi">Delhi</option>
              <option value="Lakshadweep">Lakshadweep</option>
              <option value="Puducherry">Puducherry</option>
              <option value="Goa">Goa</option>
              <option value="Gujarat">Gujarat</option>
              <option value="Haryana">Haryana</option>
              <option value="Himachal Pradesh">Himachal Pradesh</option>
              <option value="Jammu and Kashmir">Jammu and Kashmir</option>
              <option value="Jharkhand">Jharkhand</option>
              <option value="Karnataka">Karnataka</option>
              <option value="Kerala">Kerala</option>
              <option value="Madhya Pradesh">Madhya Pradesh</option>
              <option value="Maharashtra">Maharashtra</option>
              <option value="Manipur">Manipur</option>
              <option value="Meghalaya">Meghalaya</option>
              <option value="Mizoram">Mizoram</option>
              <option value="Nagaland">Nagaland</option>
              <option value="Odisha">Odisha</option>
              <option value="Punjab">Punjab</option>
              <option value="Rajasthan">Rajasthan</option>
              <option value="Sikkim">Sikkim</option>
              <option value="Tamil Nadu">Tamil Nadu</option>
              <option value="Telangana">Telangana</option>
              <option value="Tripura">Tripura</option>
              <option value="Uttar Pradesh">Uttar Pradesh</option>
              <option value="Uttarakhand">Uttarakhand</option>
              <option value="West Bengal">West Bengal</option>
            </select>
            <br />
            <br />
            <button className="sett-sub" type="submit">
              Save Details
            </button>
          </form>
        </div>
      ) : (
        <div>
          <h1 style={{ textAlign: "center" }}>Regestration has Been Closed.</h1>
          <p style={{ textAlign: "center" }}>
            <i>
              If Already Registered, Please Login with the Registered Email
              Address To Download Certificate
            </i>
          </p>
        </div>
      )}
    </div>
  );
};

export default AddUser;
